// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconClicked svg[data-v-64c56500] {\n  color: #1A7BEE;\n}", ""]);
// Exports
module.exports = exports;
